/* istanbul ignore file */
import OurStory from './OurStory';

export default OurStory;
